import { makeRequest } from 'utils/requestLogger';

export default (id) =>
    makeRequest(
        'get',
        `/api/courses/${id}/get_student_activities/me`
    ).then((res) => res.data);


// WEBPACK FOOTER //
// ./src/app/services/courses/getMyStudentActivities.js